module.exports = __webpack_public_path__ + "static/img03-64231ce7a6b31739a705c74b72d07600.jpg";